module.exports = __webpack_public_path__ + "static/media/flight_on_a_line.e7666b84.png";